import cn from "@/util/cn"

type HeroImageProps = {
  src: string
  alt?: string
  className?: string
}

const HeroImage = ({ src, alt = "", className }: HeroImageProps) => (
  <img
    src={src}
    alt={alt}
    className={cn(
      "-mx-6 -mt-4 mb-6 h-[40vh] w-screen max-w-none object-fill",
      className
    )}
  />
)

export default HeroImage
